import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import NewCollectionItem from './NewCollectionItem'
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import PersonalItems from './personalItems'
import NonPersonal from './NonPersonalItems'
import * as collectionItemsService from '../../services/collectionItemsService'
import * as fileService from '../../services/fileService'

class CollectionItems extends Component {
    state = {
        showFileModal: false,
        showKey: "",
        sendMessage:'',
        isSending:false,
        sendAttachmentForm:{
            fileToSend:{},
            receiverEmail:""
      
          },
        fileName: "",
        showCollectionItemsModal: false,
        sendFileModalForPersonalItems:false,
        sendFileModalForNonPersonalItems:false,
        sendFileButtonDisabled:true,
        singlePersonalItem:{},
        singlePersonalItemModal:false,
        singleNonPersonalItem:{},
        singleNonPersonalItemModal:false,
        search: '',
        itemToDelete:'',
        isDeleting:false,
        isChangingStatus:false,
        changeStatusMessage:'',
        deleteMessage:'',
        isOpening:false,
        staffsInformation:{
            ActiveStaffs:"",
            InactiveStaffs:"",
            showStaffsModal:false,
        }
    }
    handleChangeSenderEmail = (e) => {
        let sendAttachmentForm = {...this.state.sendAttachmentForm}
        let { sendFileButtonDisabled } = this.state
        sendAttachmentForm.receiverEmail = e.target.value
        if(sendAttachmentForm.receiverEmail.length > 0){
            this.setState({sendFileButtonDisabled:false})
        }else{
            this.setState({sendFileButtonDisabled:true})
        }
        this.setState({sendAttachmentForm})
      
        if(e.target.name === 'search') {
            this.setState({search : e.target.value})
        }
      }
    
    deleteCollectionItem = async(id) => {
        this.setState({isDeleting:true})
        let response = await collectionItemsService.deleteCollectionItem(id);
        if (response.status === 200){
            this.setState({deleteMessage:response.message})
            this.setState({isDeleting:false})
            setTimeout(() => {
                window.location.reload()
            }, 300);
        }
    }
    fetchNumberOfActiveAndInactiveStaffs = async(id) => {
        let response = await collectionItemsService.getNumberOfActiveAndInactiveStaffs(id);
        let { numberOfActiveStaffs , numberOfInactiveStaffs } = await response.data
        let staffsInformation = { ...this.state.staffsInformation }
        staffsInformation.ActiveStaffs = numberOfActiveStaffs
        staffsInformation.InactiveStaffs = numberOfInactiveStaffs
        staffsInformation.showStaffsModal = true
        this.setState({staffsInformation})
    }
    changeStaffStatus = async(id) =>{
        this.setState({isChangingStatus:true})
        let response = await collectionItemsService.changeStaffStatus(id)
        if (response.status === 200){
            this.setState({ changeStatusMessage:response.message})
            this.setState({isChangingStatus:false})
            setTimeout(() => {
                window.location.reload()
            }, 300);
        } 
    }
    closeStaffInformation = () =>{
        let staffsInformation = { ...this.state.staffsInformation }
        staffsInformation.showStaffsModal = false
        this.setState({staffsInformation})
    }
    showFiles = (item) => {
        const { collectionItems } = this.props;
        collectionItems.items.forEach(value => {
            if (value.id === item.id) {
                let { showFileModal, showKey } = this.state
                this.setState({
                    showKey: item.id,
                    showFileModal: !showFileModal
                })
            }
        })
    }
    openFileModalForNonPersonalItems = (file) => {
        let sendAttachmentForm = {...this.state.sendAttachmentForm}
        sendAttachmentForm.fileToSend = file
        this.setState({sendAttachmentForm})
        this.setState({sendFileModalForNonPersonalItems:true})
    }
    closeFileModalForPersonalItems = ()=>{
        let sendAttachmentForm = {...this.state.sendAttachmentForm}
        sendAttachmentForm.receiverEmail = ""
        let { sendFileButtonDisabled } = this.state
        this.setState({sendMessage:""})
        this.setState({sendFileModalForPersonalItems:false})
        this.setState({sendAttachmentForm})
        this.setState({sendFileButtonDisabled:true})
    }
    closeFileModalForNonPersonalItems = ()=>{
        let sendAttachmentForm = {...this.state.sendAttachmentForm}
        let { sendFileButtonDisabled } = this.state
        sendAttachmentForm.receiverEmail = ""
        this.setState({sendMessage:""})
        this.setState({sendFileModalForNonPersonalItems:false})
        this.setState({sendAttachmentForm})
        this.setState({sendFileButtonDisabled:true})
    }
    closeSinglePersonalItemModal = ()=>{
        this.setState({singlePersonalItem:[]})
        this.setState({itemToDelete:''})
        this.setState({singlePersonalItemModal:false})
    }
    closeSingleNonPersonalItemModal = ()=>{
        this.setState({singleNonPersonalItem:[]})
        this.setState({itemToDelete:''})
        this.setState({singleNonPersonalItemModal:false})
    }
    showCollectionItemModal = () => {
        this.setState({ showCollectionsItemModal: true })
    }
    hideCollectionItemModal = () => {
        this.setState({ showCollectionsItemModal: false })
    }
    viewSinglePersonalItem = async(item) =>{
      let response = await collectionItemsService.fetchSingleCollectionItem(item.id)
      let {items:singlePersonalItem , itemId:itemToDelete} = await response.data
      this.setState({singlePersonalItem})
      this.setState({itemToDelete})
      this.setState({singlePersonalItemModal:true})
    }
    viewSingleNonPersonalItem = async(item) =>{
      let response = await collectionItemsService.fetchSingleCollectionItem(item.id)
      let {items:singleNonPersonalItem , itemId:itemToDelete} = await response.data
      this.setState({singleNonPersonalItem})
      this.setState({itemToDelete})
      this.setState({singleNonPersonalItemModal:true})   

    }
    submitSendAttachmentForm = async(e) => {
        e.preventDefault()
        this.setState({isSending:true})
        let { id } = this.state.sendAttachmentForm.fileToSend
        let sendAttachmentForm = {...this.state.sendAttachmentForm}
        const response = await fileService.fileSending(id ,this.state.sendAttachmentForm.receiverEmail)
        const sendMessage = response.message
        this.setState({sendMessage})
        this.setState({isSending:false})
        sendAttachmentForm.receiverEmail = ""
        this.setState({sendAttachmentForm})
    }
    render() {
        let {  title, id  } = this.props.collectionItems
        let { loadingData, departmentId, searchValue, items, collectionItems, personalSearch,loadingCollections } = this.props
        let { showFileModal, showKey ,singlePersonalItem,singleNonPersonalItem,singleNonPersonalItemModal,sendFileButtonDisabled ,singlePersonalItemModal} = this.state
        if(loadingCollections === false){
            if (typeof (items) !== 'undefined') {
                if (title !== 'Personal Staff Files') {
                    //table for Non Personal Staff Files
                    if(collectionItems.items) {
                        if (collectionItems.items.length > 0) {
                            return (
                                <div style={{ width: '100%' }} className="h-full bg-white rounded-md">
                                    <React.Fragment>
        
                                        <div className="flex justify-between w-full p-4">
                                            <Link className="flex justify-end px-3 py-1 text-sm text-white rounded-md bg-wvrblue" to={`/collections/createItem/${departmentId}/${title}/${id}`}>
                                                <div className="mt-1">
                                                New Item
                                                </div>
                                            </Link>
                                            <span className="mt-2 ml-8 text-sm font-extrabold capitalize">{title} Collection items</span>
                                            <div className="flex justify-end ml-8">
                                            <input
                                                onChange={searchValue}
                                                name="search"
                                                placeholder="Search..."
                                                type="text"
                                                className="w-full px-3 py-2 mt-0 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm  form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                                                />
                                            </div>
                                        </div>
        
                                        <div className="w-full h-full overflow-auto rounded-md" >
                                        <NonPersonal
                                                items= {items}
                                                showKey = {showKey}
                                                showFileModal =  {showFileModal}
                                                title ={title}
                                                departmentId = {departmentId}
                                                showFiles={this.showFiles}
                                                openFileModalForNonPersonalItems = {this.openFileModalForNonPersonalItems}
                                                viewSingleNonPersonalItem = {this.viewSingleNonPersonalItem}
                                            />
                                        </div>
                                        {
                                            this.state.sendFileModalForNonPersonalItems && (
                                                <div className="fixed top-0 left-0 z-10 w-screen h-screen ">
                                                    <div className="absolute z-50 flex flex-col px-10 py-4 my-4 bg-white border-2 border-black bottom-8 left-96 right-96">
                                                        <div className="flex flex-col my-4 text-wvrDarkPrimary">
                                                        <div className="flex">
                                                        <p className="font-bold text-left">Send File</p>
                                                        {
                                                            this.state.sendMessage && 
                                                            <p className="ml-8 text-sm font-bold text-red-600">{this.state.sendMessage}</p>
                                                        }
                                                        </div>
                                                            <form onSubmit={this.submitSendAttachmentForm}>
                                                            <div className="flex flex-row w-full gap-8 py-2">
                                                                    <div className="flex flex-col w-full">
                                                                        <label className="mb-1 text-sm">
                                                                        Receiver Email
                                                                        </label>
                                                                        <input type="email" value={this.state.sendAttachmentForm.receiverEmail} onChange={this.handleChangeSenderEmail}  name="" id="" placeholder="Fill in the field" className="p-2 text-xs border-2 rounded-md border-wvrPrimary "/>
                                                                    </div>
                                                                </div>
        
                                                               <div className="flex flex-row w-full gap-8 py-2">
                                                                    <div className="flex flex-col w-full">
                                                                        <label className="mb-1 text-sm">
                                                                        File To Send
                                                                        </label>
                                                                        <input readOnly type="text" value={this.state.sendAttachmentForm.fileToSend.name} name="" id="" placeholder="Fill in the field" className="p-2 text-xs border-2 rounded-md border-wvrPrimary "/>
                                                                        <input readOnly type="hidden" value={this.state.sendAttachmentForm.fileToSend.id} name="" id="" placeholder="Fill in the field" className="p-2 text-xs border-2 rounded-md border-wvrPrimary "/>
                                                                    </div>
                                                                </div>
        
                                                                <div className="flex flex-row gap-4 my-4">
                                                                    <button type="submit" disabled={this.state.isSending ? "disabled":""}  className={!this.state.isSending ?"bg-wvrblue text-white py-2 px-8 rounded-md":"bg-blue-300 text-white py-2 px-8 rounded-md"}>
                                                                        {this.state.isSending ? "Sending....":"Send Attachment"}
                                                                    </button>
                                                                    <button className="px-8 py-2 rounded-md bg-wvrPrimary" onClick={this.closeFileModalForNonPersonalItems}>cancel</button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                    </div>
                                            )
                                        }
                                        {
                                            singleNonPersonalItemModal && (
                                                <div className="fixed top-0 left-0 z-10 w-screen h-screen ">
                                                <div className="absolute z-50 flex flex-col px-10 py-4 my-4 bg-white border-2 border-black bottom-8 left-96 right-96">
                                                    <div className="flex flex-col my-4 text-wvrDarkPrimary">
                                                         <div className="flex">
                                                        <p className="font-bold text-left">View Document</p>
                                                        {
                                                            this.state.deleteMessage && 
                                                            <p className="ml-8 text-sm font-bold text-red-600">{this.state.deleteMessage}</p>
                                                        }
                                                        </div>
                                                        <div className="mt-4 overflow-y-auto text-center md:text-left">
                                                            <div className="w-full h-full bg-white rounded-md">
                                                               {
                                                                   Object.keys(singleNonPersonalItem).map(function(key,value){
                                                                    return(
                                                                        <>                    
                                                                        <div className="flex flex-row w-full gap-8 py-2">
                                                                             <div className="flex flex-col w-1/2">
                                                                                 <label className="mb-1 text-sm">
                                                                                    {key}:
                                                                                </label>
                                                                                <div className="mt-2">
                                                                                    <p className="text-wvrOrange">{singleNonPersonalItem[key]}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <hr />
                                                                        </>
                                                                    )
                                                                   })
                                                               }
                                                            </div>
                                                         </div>
                                                            <div className="flex flex-row gap-4 my-4">
                                                                <button className="px-8 py-2 rounded-md bg-wvrPrimary" onClick={this.closeSingleNonPersonalItemModal}>Close</button>
                                                                <button disabled={this.state.isDeleting ? "disabled" :""} className={this.state.isDeleting ? "py-2 px-8 rounded-md text-white bg-yellow-300":"bg-wvrOrange py-2 px-8 rounded-md text-white"} onClick={()=>this.deleteCollectionItem(this.state.itemToDelete)}>
                                                                       {this.state.isDeleting ? "Deleting...." :"Delete"}
                                                                </button>
                                                            </div>
                                                    </div>
                                                </div>
                                                </div>
                                            )
                                        }
                                    </React.Fragment>
                                </div>
                            );
                        } else {
                            return (
                                <React.Fragment>
                                    <div className="flex px-16 ">
                                        <span className="items-center justify-center text-sm font-bold text-red-600 mt-28 ">
                                            {title} collection has no Items yet <Link className="px-3 py-1 text-sm font-semibold text-blue-700 rounded-md" to={`/collections/createItem/${departmentId}/${title}/${id}`}>Create New</Link>
                                        </span>
                                    </div>
        
                                </React.Fragment>
                            )
                        }
                    }else {
                        return(
                            <div></div>
                        )
                    }
                    
                } else {
                    //Table for Personal Staff Files
                    if(collectionItems.items) {
                        if (collectionItems.items.length > 0) {
                            return (
                                <div className="w-full bg-white rounded-md">
                                    <React.Fragment >
                                        <div className="flex justify-between w-full p-4">
                                            <Link className="flex justify-end px-2 py-1 text-sm text-white rounded-md bg-wvrOrange" to={`/collections/createItem/${departmentId}/${title}/${id}`}>
                                            <div className="mt-1">
                                                New Item
                                                </div>
                                            </Link>
                                            <button disabled={this.state.staffsInformation.showStaffsModal? "disabled" : ""} onClick={()=>this.fetchNumberOfActiveAndInactiveStaffs(this.props.collectionItems.id)} className={
                                                !this.state.staffsInformation.showStaffsModal ? "bg-wvrOrange text-white text-sm px-2 py-1 rounded-md flex" : "bg-yellow-300 text-white text-sm px-2 py-1 rounded-md flex"
                                            }> 
                                                <div className="mt-1">
                                                   Staffs Status
                                                </div>
                                            </button>
                                            <span className="mt-2 ml-8 text-sm font-extrabold capitalize">{title} Collection items</span>
                                                <div className="flex justify-end px-8">
                                                    <input
                                                        onChange={personalSearch}
                                                        name="search"
                                                        placeholder="Search ..."
                                                        type="text"
                                                        className="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm  form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                                                        />
                                                </div>
                                        </div>
                                        {
                                                    this.state.staffsInformation.showStaffsModal &&(
                                                        <div className="fixed z-20 w-64 text-xs bg-white border-2 border-white rounded-md top-8 right-2">
                                                        <div className="flex flex-row justify-between gap-4 px-4 py-2">
                                                            <div className="p-1 rounded-md  bg-wvrOrange">
                                                                <div className="p-1 rounded-full bg-wvrOrange">
                                                                    <p className="text-white"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg></p>
                                                                </div>
                                                            </div>
                                                            <div className="items-center">
                                                                <p className="text-wvrOrange">Active Staffs: <span className="font-bold">{this.state.staffsInformation.ActiveStaffs}</span></p>
                                                                <p className="text-wvrOrange">Inactive Staffs: <span className="font-bold">{this.state.staffsInformation.InactiveStaffs}</span></p>
                                                            </div>
                                                           
                                                            <button className="font-bold align-middle text-wvrOrange" onClick={this.closeStaffInformation}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    )
                                                   
                                                }
                                        <div className="w-full h-full overflow-auto rounded-md">
                                            <PersonalItems
                                                items= {items}
                                                showKey = {showKey}
                                                showFileModal =  {showFileModal}
                                                title ={title}
                                                showFiles={this.showFiles}
                                                openFileModalForPersonalItems = {this.openFileModalForPersonalItems}
                                                viewSinglePersonalItem = {this.viewSinglePersonalItem}
                                                departmentId = {departmentId}
                                            />
                                        </div>
                                        {
                                            singlePersonalItemModal && (
                                                <div className="fixed top-0 left-0 z-10 w-screen h-screen ">
                                                <div className="absolute z-50 flex flex-col px-10 py-4 my-4 bg-white border-2 border-black bottom-8 left-96 right-96">
                                                    <div className="flex flex-col my-4 text-wvrDarkPrimary">
                                                        <div className="flex">
                                                        <p className="font-bold text-left">View Document</p>
                                                        {
                                                            this.state.deleteMessage && 
                                                            <p className="ml-8 text-sm font-bold text-red-600">{this.state.deleteMessage}</p>
                                                        }
                                                        {
                                                            this.state.changeStatusMessage && 
                                                            <p className="ml-8 text-sm font-bold text-red-600">{this.state.changeStatusMessage}</p>
                                                        }
                                                        </div>
                                                        <div className="mt-4 overflow-y-auto text-center md:text-left">
                                                            <div className="w-full h-full bg-white rounded-md">
                                                            {
                                                                   Object.keys(singlePersonalItem).map(function(key,value){
                                                                    return(
                                                                        <>                    
                                                                        <div className="flex flex-row w-full gap-8 py-2">
                                                                             <div className="flex flex-col w-1/2">
                                                                                 <label className="mb-1 text-sm">
                                                                                    {key}:
                                                                                </label>
                                                                                <div className="mt-2">
                                                                                    <p className="text-wvrOrange">{singlePersonalItem[key]}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <hr />
                                                                        </>
                                                                    )
                                                                   })
                                                               }
                                                            
                                                            </div>
                                                         </div>
                                                            <div className="flex flex-row gap-4 my-4">
                                                                <button className="px-8 py-2 rounded-md bg-wvrPrimary" onClick={this.closeSinglePersonalItemModal}>Close</button>
                                                                <button disabled={this.state.isDeleting ? "disabled" :""} className={this.state.isDeleting ? "py-2 px-8 rounded-md text-white bg-yellow-300":"bg-wvrOrange py-2 px-8 rounded-md text-white"} onClick={()=>this.deleteCollectionItem(this.state.itemToDelete)}>
                                                                    {this.state.isDeleting ? "Deleting...." :"Delete"}
                                                                </button>
                                                                <button disabled={this.state.isChangingStatus ? "disabled" :""} className={this.state.isChangingStatus ? "py-2 px-8 rounded-md text-white bg-yellow-300":"bg-wvrOrange py-2 px-8 rounded-md text-white"} onClick={()=>this.changeStaffStatus(this.state.itemToDelete)}>
                                                                    {this.state.isChangingStatus ? "please wait...." :"Change Status"}
                                                                </button>
                                                            </div>
                                                    </div>
                                                </div>                                                
                                                </div>
                                            )
                                        }
        
                                    </React.Fragment>
                                </div>
        
                            )
                        }else {
                            return (
                                <React.Fragment>
                                <div className="flex px-16 ">
                                    <span className="items-center justify-center text-sm font-bold text-red-600 mt-28 ">
                                        {title} collection has no Items yet <Link className="px-3 py-1 text-sm font-semibold text-blue-700 rounded-md" to={`/collections/createItem/${departmentId}/${title}/${id}`}>Create New</Link>
                                    </span>
                                </div>
    
                            </React.Fragment>
                            )
                        }
                    } else {
                        <div></div>
                    }
                }
            } else {
                return (
                    <div className="px-32 py-16 bg-transparent">
                        <span className="mt-12 text-sm font-bold text-red-700">
                            Please select a Collection To view
                        </span>
                    </div>
                )
            }
        }else{
            //fetching
            return (
               <div className="justify-center">
                   <p className="font-bold text-red-600 text-medium">Please wait.....</p>
               </div>
            )
        }
     

    }
}


export default CollectionItems;
